import Link from "next/link";

import { imageUrlFor } from "lib/remoteContent";

import PostDetails from "components/blog/PostDetails";

import styles from "./BlogCard.module.css";

import type { BlogPost } from "lib/remoteContent";

const BlogCard = ({ post }: { post: BlogPost }) => {
  return (
    <Link href={`/blog/${post.slug}`}>
      <div className={styles.card}>
        {post.thumbnail ? (
          <div
            className={styles.thumbnail}
            style={{ backgroundImage: `url(${imageUrlFor(post.thumbnail).height(516).url()})` }}
          ></div>
        ) : null}
        <div className={styles.details}>
          <h2>{post.title}</h2>
          <p>{post.description}</p>
          <PostDetails {...post} />
        </div>
      </div>
    </Link>
  );
  return <div>{post.title}</div>;
};

export default BlogCard;
